import { useStore } from 'effector-react'

import {
  $totalCountOfParticipants,
  getParticipants,
  participantsListMounted,
  $participants,
} from './model'
import { ParticipantListRequest } from './types'

export const useParticipantsList = () => {
  const participants = useStore($participants)
  const loading = useStore(getParticipants.pending)
  const totalCountOfParticipants = useStore($totalCountOfParticipants)

  const onChangeParticipantsList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: ParticipantListRequest) => {
    participantsListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  return {
    participants,
    totalCountOfParticipants,
    loading,
    onChangeParticipantsList,
  }
}
